import { useIndustry } from "../../context/IndustryContext";
import ModeIndicator from "../../components/shared/ModeIndicator";
import DemoDataNotice from "../../components/shared/DemoDataNotice";
import LanguageToggle from "../../components/shared/LanguageToggle";
import SubPageNav from "../../components/shared/SubPageNav";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTelemetry } from "../../context/TelemetryContext";

const INDUSTRY_KEY = {
  "School": "school",
  "Airport": "airport",
  "Public Event": "publicEvent",
  "Border Security": "borderSecurity",
  "Military": "military",
};

function Governance() {
const { t } = useTranslation();

const { industry } = useIndustry();
const telemetry = useTelemetry();
const governanceScore =
telemetry.overallRisk === "CRITICAL"
? 92
: telemetry.overallRisk === "WARNING"
? 78
: 98;

const governanceColor =
governanceScore > 90
? "#22c55e"
: governanceScore > 70
? "#f59e0b"
: "#ef4444";

const industryKey = INDUSTRY_KEY[industry] || "school";
const autonomyLevel = t(`governance.industry.autonomyLevels.${industryKey}`);
const policyName = t(`governance.industry.policyNames.${industryKey}`);
const governanceText = t(`governance.industry.governanceTexts.${industryKey}`);


return (

<div
style={{
padding: "20px",
color: "white"
}}
>
<div style={{position:"relative",textAlign:"center",marginBottom:"20px"}}><h1
style={{
textAlign:"center",
marginBottom:"10px"
}}
>
{t("governance.title")}
</h1><div style={{position:"absolute",top:0,right:0,display:"flex",alignItems:"flex-start",gap:"12px"}}><LanguageToggle /><ModeIndicator /></div></div>

<p
style={{
textAlign:"center",
color:"#94a3b8",
marginBottom:"25px"
}}
>
{t("governance.subtitle")}
</p>

<div
style={{
display: "grid",
gridTemplateColumns: "1fr 1fr",
gap: "20px"
}}
>

{/* Autonomy Level */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("governance.autonomyLevel.title")}</h3>

<h2
style={{
marginTop: "15px",
color: "#38bdf8"
}}
>
{autonomyLevel}
</h2>

<p
style={{
marginTop: "10px",
color: "#94a3b8"
}}
>
{t("governance.autonomyLevel.industry", { industry })}

</p>

<p style={{ color: "#94a3b8" }}>
{governanceText}
</p>

</div>

{/* Human Oversight */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("governance.humanOversight.title")}</h3>

<p>{t("governance.humanOversight.operatorReview", { value: t("commandCenter.status.active") })}</p>

<p>{t("governance.humanOversight.decisionApproval", { value: t("commandCenter.status.required") })}</p>

<p>{t("governance.humanOversight.supervisorVisibility", { value: t("commandCenter.status.enabled") })}</p>

</div>

{/* Explainability */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("governance.explainability.title")}</h3>

<div style={{ marginTop: "15px" }}>

{telemetry.explanations?.map((item, index) => (

<div
key={index}
style={{
marginBottom: "10px",
color: "#94a3b8"
}}
>
✓ {t(`commandCenter.telemetryExplanations.${item}`, item)}
</div>

))}

</div>

</div>

{/* Policy Compliance */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("governance.policyCompliance.title")}</h3>

<p>{t("governance.policyCompliance.compliant", { policy: policyName, value: t("commandCenter.status.compliant") })}</p>

<p>{t("governance.policyCompliance.auditLogging", { value: t("commandCenter.status.active") })}</p>

<p>{t("governance.policyCompliance.privacyControls", { value: t("commandCenter.status.enabled") })}</p>

</div>

</div>



{/* ===================================================== */}
{/* GOVERNANCE INTELLIGENCE HUB */}
{/* ===================================================== */}

<div
style={{
marginTop:"30px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"25px"
}}
>
{t("governance.hub.title")}
</h3>

{/* ============================ */}
{/* GOVERNANCE SUMMARY */}
{/* ============================ */}

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px",
marginBottom:"25px"
}}
>

<div style={{textAlign:"center"}}>
<h4>{t("governance.hub.complianceScore")}</h4>
<h2 style={{color:governanceColor}}>
{governanceScore}%
</h2>
<p style={{color:"#94a3b8"}}>
{t("governance.hub.policyConfidence")}
</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("governance.hub.humanOversight")}</h4>
<h2 style={{color:"#38bdf8"}}>
{t("commandCenter.status.active")}
</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("governance.hub.auditReadiness")}</h4>
<h2 style={{color:"#22c55e"}}>
{t("commandCenter.status.ready")}
</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("governance.hub.aiTransparency")}</h4>
<h2 style={{color:"#22c55e"}}>
{t("commandCenter.status.verified")}
</h2>
</div>

</div>

<hr
style={{
border:"1px solid #1e293b",
margin:"20px 0"
}}
/>

{/* ============================ */}
{/* RESPONSIBLE AI */}
{/* ============================ */}

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px",
marginBottom:"25px"
}}
>

<div style={{textAlign:"center"}}>
<h4>{t("governance.hub.biasMonitoring")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.pass")}</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("governance.hub.safetyControls")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("governance.hub.policyValidation")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.verified")}</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("governance.hub.riskControls")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.enabled")}</p>
</div>

</div>

<hr
style={{
border:"1px solid #1e293b",
margin:"20px 0"
}}
/>

{/* ============================ */}
{/* APPROVAL WORKFLOW */}
{/* ============================ */}

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px",
textAlign:"center"
}}
>

<div>
<h4>{t("governance.hub.request")}</h4>
<p>{t("governance.hub.generated")}</p>
</div>

<div>
<h4>{t("governance.hub.review")}</h4>
<p>{t("governance.hub.supervisor")}</p>
</div>

<div>
<h4>{t("governance.hub.approval")}</h4>
<p>{t("governance.hub.required")}</p>
</div>

<div>
<h4>{t("governance.hub.action")}</h4>
<p>{t("governance.hub.authorized")}</p>
</div>

</div>

</div>



{/* ===================================================== */}
{/* GOVERNANCE ACCOUNTABILITY CENTER */}
{/* ===================================================== */}
<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b",
color:"#cbd5e1",
fontSize:"14px",
fontWeight:"500",
padding:"12px 0"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"25px"
}}
>
{t("governance.accountabilityCenter.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px",
textAlign:"center",
margin:"25px 0"
}}
>

<div>
<h4>{t("governance.accountabilityCenter.decisionsAudited")}</h4>
<h2 style={{color:"#38bdf8"}}>1284</h2>
<DemoDataNotice textKey="common.demoDataNotice.simulatedCount" />
</div>

<div>
<h4>{t("governance.accountabilityCenter.approvalRate")}</h4>
<h2 style={{color:"#22c55e"}}>99.2%</h2>
<DemoDataNotice textKey="common.demoDataNotice.illustrativeFigure" />
</div>

<div>
<h4>{t("governance.accountabilityCenter.humanOverrides")}</h4>
<h2 style={{color:"#f59e0b"}}>4</h2>
</div>

<div>
<h4>{t("governance.accountabilityCenter.escalations")}</h4>
<h2 style={{color:"#ef4444"}}>12</h2>
</div>

</div>

<hr
style={{
border:"1px solid #1e293b",
margin:"20px 0"
}}
/>

<div
style={{
textAlign:"center",
color:"#94a3b8",
lineHeight:"2",
fontSize:"18px",
fontWeight:"500",
padding:"10px 0"
}}
>
✓ {t("governance.accountabilityCenter.riskClassificationReviewed")} &nbsp; | &nbsp;
✓ {t("governance.accountabilityCenter.explainabilityVerified")} &nbsp; | &nbsp;
✓ {t("governance.accountabilityCenter.policyValidationCompleted")} &nbsp; | &nbsp;
✓ {t("governance.accountabilityCenter.humanApprovalRecorded")}
</div>

</div>

{/* ===================================================== */}
{/* GOVERNANCE OPERATIONS STATUS */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"25px"
}}
>
{t("governance.operationsStatus.title")}
</h3>

{/* ============================ */}
{/* COMPLIANCE STATUS */}
{/* ============================ */}

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px",
textAlign:"center",
marginBottom:"25px"
}}
>

<div>
<h4>{t("governance.operationsStatus.privacy")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.pass")}</p>
</div>

<div>
<h4>{t("governance.operationsStatus.transparency")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.pass")}</p>
</div>

<div>
<h4>{t("governance.operationsStatus.safety")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.pass")}</p>
</div>

<div>
<h4>{t("governance.operationsStatus.governance")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.pass")}</p>
</div>

</div>

<hr
style={{
border:"1px solid #1e293b",
margin:"20px 0"
}}
/>

{/* ============================ */}
{/* AGENT NETWORK */}
{/* ============================ */}

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px",
textAlign:"center",
marginBottom:"25px"
}}
>

<div>
<h4>{t("governance.agentNetwork.governanceAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div>
<h4>{t("governance.agentNetwork.explainabilityAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div>
<h4>{t("governance.agentNetwork.decisionAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div>
<h4>{t("governance.agentNetwork.memoryAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

</div>

<hr
style={{
border:"1px solid #1e293b",
margin:"20px 0"
}}
/>

{/* ============================ */}
{/* CONFIDENCE METER */}
{/* ============================ */}

<h4
style={{
textAlign:"center",
marginBottom:"15px"
}}
>
{t("governance.operationsStatus.confidenceTitle")}
</h4>

<div
style={{
width:"100%",
height:"28px",
background:"#0f172a",
borderRadius:"20px",
overflow:"hidden"
}}
>

<div
style={{
width:`${governanceScore}%`,
height:"100%",
background:governanceColor
}}
/>

</div>

<div
style={{
textAlign:"center",
marginTop:"12px",
fontSize:"24px",
fontWeight:"bold",
color:governanceColor
}}
>
{governanceScore}%
</div>

</div>

{/* ===================================================== */}
{/* GOVERNANCE RECOMMENDATIONS */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("governance.recommendations.title")}
</h3>

<div
style={{
display:"flex",
justifyContent:"center",
gap:"40px",
flexWrap:"wrap",
marginTop:"20px"
}}
>
{
telemetry.overallRisk === "CRITICAL"
? (
<>
<p>{t("governance.recommendations.criticalImmediateReview")}</p>
<p>{t("governance.recommendations.criticalLockActions")}</p>
<p>{t("governance.recommendations.criticalEscalateTeam")}</p>
</>
)
: telemetry.overallRisk === "WARNING"
? (
<>
<p>{t("governance.recommendations.warningIncreaseReview")}</p>
<p>{t("governance.recommendations.warningMonitorCompliance")}</p>
<p>{t("governance.recommendations.warningNotifySupervisor")}</p>
</>
)
: (
<>
<p>{t("governance.recommendations.safeContinueMonitoring")}</p>
<p>{t("governance.recommendations.safeMaintainAudit")}</p>
<p>{t("governance.recommendations.safeNoIntervention")}</p>
</>
)
}


</div>

</div>

{/* ===================================================== */}
{/* EXECUTIVE GOVERNANCE SUMMARY */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b",
textAlign:"center"
}}
>

<h3>
{t("governance.summary.title")}
</h3>

<p
style={{
marginTop:"15px",
color:"#94a3b8"
}}
>
{t("governance.summary.text")}
</p>

</div>

<SubPageNav current="governance" />

</div>

);

}

export default Governance;